import { store } from "@/store/store";
import {
    VuexModule, Mutation, getModule, Module, Action
} from "vuex-module-decorators";

import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import { CartHistory } from "@/shared/dtos/CartHistory";
import { CartItem } from "@/shared/dtos/CartItem";
import { TiendaCartHistoryLocalService } from "@/shared/services/tienda_cart_history_local_service";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { Cart } from "@/shared/dtos/Cart";
import { clients } from "@/shared/dtos/clients";
import { CartsClientsdto } from "@/shared/dtos/carts_clientes/CartsClientsdto";
import { CartDTO } from "@/shared/dtos/carts_clientes/Cartdto";
import { itemDto } from "@/shared/dtos/carts_clientes/itemdto";

@Module({
    namespaced: true,
    name: "TiendaCartModule",
    store,
    dynamic: true
})
class tienda_cart_module extends VuexModule {
    public cartHistory: CartHistory = new CartHistory();
    // Compatibilidad: representación plana del carrito actual (array de productos)
    public carritoCompra: ProductoAmazon[] = [];
    public allCarts: Array<{ cart: any; client: any; items: itemDto[] }> = [];
    public carts_loaded: CartsClientsdto[] = [];
    // ========== ACTIONS (persistencia remota) ==========


    @Action({ commit: "onAllCarts" })
    public async getAllCarts() {
        return await ssmHttpService.get(API.carts + "/all-with-items");
    }

    @Action
    public async deleteCart(cartId: number) {
        return await ssmHttpService.delete(API.carts + '/' + cartId, null);
    }

    @Action
    public async deleteCartItem(itemId: number) {
        return await ssmHttpService.delete(API.cartItems + '/' + itemId, null);
    }



    // ========== ACTIONS (persistencia local centralizada) ==========

    @Action({ commit: "onSetCartHistory" })
    public async loadCart() {
        var loaded = TiendaCartHistoryLocalService.load();
        if (loaded) { return loaded; }
        return new CartHistory();
    }

    @Action({ commit: "onAddProductInternal" })
    public async addProductToCart(product: ProductoAmazon) {
        return product;
    }

    @Action
    public removeFromCart(productId: number) {
        this.context.commit("onRemoveProductInternal", productId);
    }

    @Action
    public clearCart() {
        this.context.commit("onClearCartInternal");
    }

    @Action
    public updateQty(payload: { productId: number; qty: number }) {
        this.context.commit("onUpdateQtyInternal", payload);
    }

    @Action
    public finalizeCurrent(pushToHistory: boolean = true) {
        this.context.commit("onFinalizeCurrentInternal", pushToHistory);
    }

    @Action
    public save() {
        this.context.commit("onSaveCartHistory", this.cartHistory);
    }

    // ========== MUTATIONS (siempre guardan en local al final) ==========

    @Mutation
    public onSetCartHistory(res: CartHistory) {
        if (res) {
            this.cartHistory = new CartHistory(res as any);
        } else {
            this.cartHistory = new CartHistory();
        }
        // sync plano
        this.carritoCompra = this.cartHistory.current.items.map(function (i) {
            return i.product as ProductoAmazon;
        });
        // persistir
        TiendaCartHistoryLocalService.save(this.cartHistory);
    }

    @Mutation
    public onAddProductInternal(product: ProductoAmazon) {
        // añade 1 unidad
        this.cartHistory.current.addItem(product, 1);
        this.carritoCompra = this.cartHistory.current.items.map(function (i) {
            return i.product as ProductoAmazon;
        });
        TiendaCartHistoryLocalService.save(this.cartHistory);
    }

    @Mutation
    public onRemoveProductInternal(productId: number) {
        this.cartHistory.current.removeItemByProductId(productId);
        this.carritoCompra = this.cartHistory.current.items.map(function (i) {
            return i.product as ProductoAmazon;
        });
        TiendaCartHistoryLocalService.save(this.cartHistory);
    }

    @Mutation
    public onClearCartInternal() {
        this.cartHistory.current.clear();
        this.carritoCompra = [];
        TiendaCartHistoryLocalService.save(this.cartHistory);
    }

    @Mutation
    public onUpdateQtyInternal(payload: { productId: number; qty: number }) {
        if (!payload) { return; }
        this.cartHistory.current.updateQty(payload.productId, payload.qty);
        this.carritoCompra = this.cartHistory.current.items.map(function (i) {
            return i.product as ProductoAmazon;
        });
        TiendaCartHistoryLocalService.save(this.cartHistory);
    }

    @Mutation
    public onFinalizeCurrentInternal(pushToHistory: boolean) {
        this.cartHistory.finalizeCurrent(pushToHistory);
        this.carritoCompra = this.cartHistory.current.items.map(function (i) {
            return i.product as ProductoAmazon;
        });
        TiendaCartHistoryLocalService.save(this.cartHistory);
    }
    @Mutation
    public onSaveCartHistory(res: CartHistory) {
        if (res) {
            this.cartHistory = new CartHistory(res as any);
        } else {
            this.cartHistory = new CartHistory();
        }
        // sync plano
        this.carritoCompra = this.cartHistory.current.items.map(function (i) {
            return i.product as ProductoAmazon;
        });
        // persistir
        TiendaCartHistoryLocalService.save(this.cartHistory);
    }

    @Mutation
    public onAllCarts(res: Array<{ cart: any; client: any; items: any[] }>) {
        if (!res || !Array.isArray(res)) {
            this.carts_loaded = [];
            this.allCarts = [];
            return;
        }

        const mapped = res.map((entry): CartsClientsdto => {
            const cartObj = entry && entry.cart ? entry.cart : {};
            const clientObj = entry && entry.client ? entry.client : {};

            const cart = new CartDTO(cartObj as any);
            const client = new clients(clientObj as any);

            const itemsSrc = entry && entry.items ? entry.items : [];
            const items = itemsSrc.map((it: any) => {
                var newItem = new itemDto(it);
                var parsed: any;
                if (typeof it.product_snapshot === "string") {
                    try {
                        parsed = JSON.parse(it.product_snapshot);
                        newItem.producto_amazon = new ProductoAmazon(parsed);
                    } catch (_e2) {
                        // No es JSON válido: abortamos
                        return newItem;
                    }
                } else {
                    newItem.producto_amazon = new ProductoAmazon(it.product_snapshot);
                }
                return newItem;
            });
            cart.items = items.map((i) => {
                const ci = new CartItem();
                ci.product = i.producto_amazon;
                return ci;
            });

            return { cart: cart, client: client, items: items };
        });
        console.log("Mapped carts_loaded:", mapped);

        this.carts_loaded = mapped;
        this.allCarts = mapped;
    }

    // ========== GETTERS de compatibilidad ==========

    get getCarritoCompra(): ProductoAmazon[] {
        return this.carritoCompra;
    }

    get itemCount(): number {
        return this.cartHistory.current ? this.cartHistory.current.itemCount : 0;
    }

    get subtotal(): number {
        return this.cartHistory.current ? this.cartHistory.current.subtotal : 0;
    }
}

export default getModule(tienda_cart_module);
